import { useT } from '@/i18n/I18nProvider'

export function SecurityPage() {
  const t = useT()
  const signOut = () => {
    localStorage.removeItem('discover.jwt')
    location.href = '/auth/signin'
  }

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-1">{t('settings.security.title')}</h1>
      <p className="text-sm opacity-70 mb-6">{t('settings.security.subtitle')}</p>

      <section className="mb-6">
        <h2 className="text-sm font-medium opacity-80 mb-2">{t('settings.security.password.title')}</h2>
        <a
          href="/auth/forgot"
          className="px-3 py-1.5 text-sm rounded border inline-block"
          style={{ borderColor: 'var(--color-border)' }}
        >
          {t('settings.security.password.change')}
        </a>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-medium opacity-80 mb-2">{t('settings.security.sessions.title')}</h2>
        <p className="text-xs opacity-70 mb-2">{t('settings.security.sessions.body')}</p>
        <button
          type="button"
          onClick={signOut}
          className="px-3 py-1.5 text-sm rounded border"
          style={{ borderColor: 'var(--color-border)' }}
        >
          {t('settings.security.sessions.signout_all')}
        </button>
      </section>

      <section>
        <h2 className="text-sm font-medium opacity-80 mb-2">{t('settings.security.audit.title')}</h2>
        <p className="text-xs opacity-70">{t('settings.security.audit.body')}</p>
      </section>
    </div>
  )
}
